/**
 * Data-channel message shapes the Python agent emits via
 * `room.local_participant.publish_data`.
 */
function num(v) {
    return typeof v === "number" && Number.isFinite(v);
}
function optStr(v) {
    return v == null || typeof v === "string";
}
/**
 * Per-discriminator shape validation so a malformed message can't reach the
 * reducer. Optional-in-practice fields the reducer already coalesces
 * (transcript timestamp, handoff reason/operator_name) stay lenient.
 */
export function isDataChannelMessage(v) {
    if (typeof v !== "object" || v === null)
        return false;
    const o = v;
    switch (o.type) {
        case "llm_metrics":
            return num(o.ttftMs) && num(o.durationMs) && num(o.tokensPerSecond) &&
                num(o.promptTokens) && num(o.completionTokens);
        case "tts_metrics":
            return num(o.ttfbMs) && num(o.durationMs) && num(o.audioDurationMs) &&
                num(o.charactersCount);
        case "stt_metrics":
            return num(o.durationMs) && num(o.audioDurationMs);
        case "eou_metrics":
            return num(o.endOfUtteranceDelayMs) && num(o.transcriptionDelayMs);
        case "vad_metrics":
            return num(o.idleTimeMs) && num(o.inferenceDurationTotalMs) && num(o.inferenceCount);
        case "retrieval_latency":
            return typeof o.agent === "string" && num(o.latency) && num(o.timestamp);
        case "agent_state_changed":
            return typeof o.new_state === "string";
        case "transcript_item":
            return (o.role === "user" || o.role === "assistant") &&
                typeof o.text === "string" && (o.timestamp == null || num(o.timestamp));
        case "show_booking_form":
        case "show_booking_times":
            return true;
        case "slot_selected":
            return typeof o.start === "string" && !Number.isNaN(new Date(o.start).getTime());
        case "human_handoff_requested":
            return typeof o.handoff_id === "string" && optStr(o.reason);
        case "human_handoff_joined":
            return typeof o.handoff_id === "string" && optStr(o.operator_name);
        case "human_handoff_unavailable":
            return typeof o.handoff_id === "string";
        default:
            return false;
    }
}
